/**
 * FundGenius official domain constants.
 * Override via REACT_APP_FUNDGENIUS_* env vars in each environment.
 */

export const PUBLIC_DOMAIN =
  process.env.REACT_APP_FUNDGENIUS_PUBLIC_DOMAIN || 'fundgeniushq.com';

export const APP_DOMAIN =
  process.env.REACT_APP_FUNDGENIUS_APP_DOMAIN || 'app.fundgeniushq.com';

export const INTAKE_DOMAIN =
  process.env.REACT_APP_FUNDGENIUS_INTAKE_DOMAIN || 'intake.fundgeniushq.com';

export const API_DOMAIN = (
  process.env.REACT_APP_API_BASE_URL
  || process.env.REACT_APP_BACKEND_URL
  || 'https://api.fundelite.ai'
).replace(/\/$/, '').replace(/\/api$/, '');

export const FUNDGENIUS_DOMAINS = {
  PUBLIC_DOMAIN,
  APP_DOMAIN,
  INTAKE_DOMAIN,
  API_DOMAIN,
  PUBLIC_URL: `https://${PUBLIC_DOMAIN}`,
  WWW_URL: `https://www.${PUBLIC_DOMAIN}`,
  APP_URL: `https://${APP_DOMAIN}`,
  INTAKE_URL: `https://${INTAKE_DOMAIN}`,
  API_URL: API_DOMAIN.startsWith('http') ? API_DOMAIN : `https://${API_DOMAIN}`,
};

export const FUNDGENIUS_PLAN_DOMAIN_ENTITLEMENTS = {
  starter: {
    label: 'Starter',
    customIntakeDomains: 0,
    customAppDomains: 0,
    removeBranding: false,
    advancedRedirects: false,
  },
  pro: {
    label: 'Pro',
    customIntakeDomains: 1,
    customAppDomains: 0,
    removeBranding: false,
    advancedRedirects: false,
  },
  white_label: {
    label: 'White Label',
    customIntakeDomains: 1,
    customAppDomains: 1,
    removeBranding: true,
    advancedRedirects: false,
  },
  enterprise: {
    label: 'Enterprise',
    customIntakeDomains: 10,
    customAppDomains: 10,
    removeBranding: true,
    advancedRedirects: true,
  },
};

export function getFundGeniusDomainEntitlement(planKey = 'starter') {
  const key = String(planKey || 'starter').toLowerCase().replace(/\s+/g, '_');
  return FUNDGENIUS_PLAN_DOMAIN_ENTITLEMENTS[key] || FUNDGENIUS_PLAN_DOMAIN_ENTITLEMENTS.starter;
}

export function canConnectFundGeniusDomain(planKey, domainType) {
  const entitlement = getFundGeniusDomainEntitlement(planKey);
  if (domainType === 'intake') return entitlement.customIntakeDomains > 0;
  if (domainType === 'app') return entitlement.customAppDomains > 0;
  if (domainType === 'redirect') return entitlement.advancedRedirects || entitlement.customIntakeDomains > 0;
  return false;
}

export default FUNDGENIUS_DOMAINS;
